import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const routes = [
  {
    path: '/',
    component: () => import('../views/Base.vue'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import('../views/Feedback.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('../views/Feedback.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/rating',
        name: 'rating',
        component: () => import('../views/Rating.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/rating/id',
        name: 'report',
        component: () => import('../views/Report.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/user',
        name: 'user-list',
        component: () => import('../views/user/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/my-account',
        name: 'my-account',
        component: () => import('../views/MyAccount.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/user/create',
        name: 'add-user',
        component: () => import('../views/user/Create.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/user/:id',
        name: 'reset-password',
        component: () => import('../views/user/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/email',
        name: 'email-setting',
        component: () => import('../views/EmailSetting.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/category',
        name: 'categories-list',
        component: () => import('../views/category/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/category/update',
        name: 'update-category',
        component: () => import('../views/category/Update.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/category/:id',
        name: 'category-details',
        component: () => import('../views/category/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/location',
        name: 'location-list',
        component: () => import('../views/location/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/location/:id',
        name: 'location-details',
        component: () => import('../views/location/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/department',
        name: 'department-list',
        component: () => import('../views/department/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/department/:id',
        name: 'department-details',
        component: () => import('../views/department/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/device',
        name: 'device-list',
        component: () => import('../views/device/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/devices/:id',
        name: 'device-details',
        component: () => import('../views/device/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/feedback-tool/event',
        name: 'event-list',
        component: () => import('../views/event/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/feedback-tool/events/:id',
        name: 'event-details',
        component: () => import('../views/event/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/feedback-tool/form',
        name: 'form-list',
        component: () => import('../views/form/Listing.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/feedback-tool/forms/:id',
        name: 'form-details',
        component: () => import('../views/form/Details.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/smiley-tool',
        name: 'smiley-tool',
        component: () => import('../views/SmileyTool.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/feedback-tool',
        name: 'feedback-tool',
        component: () => import('../views/FeedbackTool.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/settings/tool',
        name: 'tool-settings',
        component: () => import('../views/settings/ToolSettings.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: '/form-builder',
        name: 'form-builder',
        component: () => import('../views/form/FormBuilder.vue'),
        beforeEnter: ifAuthenticated,
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: 'Login to Smiley Tools - Temasek Club' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: { title: 'Forgot Password - Temasek Club' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ForgotPassword.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    meta: { title: 'Reset Password - Temasek Club' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ResetPassword.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/public/e-form/:id',
    name: 'public-e-form',
    component: () => import('../views/public-form/form.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
